// Portuguese → English translation map
// Used by the t() function when language is set to 'en'

export const translations: Record<string, string> = {
  // === LOGIN ===
  'Gerencie todas suas automacoes em um so lugar.': 'Manage all your automations in one place.',
  'Bem-vindo de volta': 'Welcome back',
  'Contas ativas': 'Active accounts',
  'Mensagens enviadas': 'Messages sent',
  'Entre para gerenciar suas automacoes': 'Sign in to manage your automations',
  'Usuario': 'Username',
  'Seu usuario': 'Your username',
  'Senha': 'Password',
  'Sua senha': 'Your password',
  'Entrando...': 'Signing in...',
  'Entrar': 'Sign in',
  'Usuario ou senha incorretos': 'Invalid username or password',
  'Automacao de Instagram e Facebook': 'Instagram & Facebook Automation',

  // === SIDEBAR ===
  'Painel': 'Dashboard',
  'Contatos': 'Contacts',
  'Recuperar Comentarios': 'Comment Replies',
  'Fluxos Visuais': 'Visual Flows',
  'Sequencias': 'Sequences',
  'Publicar': 'Publish',
  'Midias': 'Media',
  'Download Midias': 'Download Media',
  'Download de Midias': 'Download Media',
  'Baixe fotos e videos de paginas do Facebook': 'Download photos and videos from Facebook pages',
  'Paginas conectadas': 'Connected pages',
  'Por URL': 'By URL',
  'Selecione uma pagina...': 'Select a page...',
  'Buscar Midias': 'Search Media',
  'Buscando...': 'Searching...',
  'Iniciando navegador...': 'Starting browser...',
  'Buscando fotos...': 'Searching photos...',
  'Buscando videos...': 'Searching videos...',
  'fotos encontradas': 'photos found',
  'videos encontrados': 'videos found',
  'Cole a URL da pagina do Facebook. O scraping pode levar alguns minutos.': 'Paste the Facebook page URL. Scraping may take a few minutes.',
  'Ocultar cookies': 'Hide cookies',
  'Colar cookies do Facebook (necessario para perfis)': 'Paste Facebook cookies (required for profiles)',
  'Cole aqui os cookies do Facebook (formato JSON do EditThisCookie)...': 'Paste Facebook cookies here (EditThisCookie JSON format)...',
  'Facebook exige login para acessar esta pagina': 'Facebook requires login to access this page',
  'Instale a extensao EditThisCookie no Chrome, acesse o Facebook logado, exporte os cookies e cole acima.': 'Install EditThisCookie Chrome extension, log in to Facebook, export cookies and paste above.',
  'Carregando cookies...': 'Loading cookies...',
  'Cookies do Facebook': 'Facebook cookies',
  'Cookies salvos': 'Cookies saved',
  'Salvar no servidor': 'Save to server',
  'Cookies salvos no servidor!': 'Cookies saved to server!',
  'Cookies invalidos - cole no formato JSON': 'Invalid cookies - paste in JSON format',
  'Cookies salvos sao usados automaticamente': 'Saved cookies are used automatically',
  'Todas': 'All',
  'Fotos': 'Photos',
  'Videos': 'Videos',
  'fotos': 'photos',
  'videos': 'videos',
  'selecionados': 'selected',
  'Tudo': 'All',
  'Limpar': 'Clear',
  'Gerando ZIP...': 'Generating ZIP...',
  'baixados': 'downloaded',
  'falharam': 'failed',
  'pronto': 'ready',
  'arquivos': 'files',
  'arquivo': 'file',
  'arquivos falharam no download': 'files failed to download',
  'Baixar ZIP': 'Download ZIP',
  'Selecione uma pagina e busque as midias': 'Select a page and search for media',
  'Cole a URL da pagina do Facebook': 'Paste the Facebook page URL',
  'Financeiro': 'Financial',
  'Paginas': 'Pages',
  'Principal': 'Main',
  'Automacao': 'Automation',
  'Conteudo': 'Content',
  'Gestao': 'Management',
  'Sistema': 'System',
  'Administrador': 'Administrator',
  'Cliente': 'Client',
  'Sair': 'Sign out',

  // === TOPBAR ===
  'Modo claro': 'Light mode',
  'Modo escuro': 'Dark mode',
  'Vincular Conta': 'Connect Account',

  // === DASHBOARD ===
  'conta': 'account',
  'contas': 'accounts',
  'validos': 'valid',
  'invalidos': 'invalid',
  'Verificando': 'Checking',
  'Verificando...': 'Checking...',
  'Verificar Tokens': 'Check Tokens',
  'Clique para verificar o status de todos os tokens': 'Click to check all token statuses',
  'Total Contas': 'Total Accounts',
  'Tokens Validos': 'Valid Tokens',
  'Tokens Invalidos': 'Invalid Tokens',
  'Nome da Conta': 'Account Name',
  'Expiracao': 'Expiration',
  'Erro': 'Error',
  'VALIDO': 'VALID',
  'EXPIRADO': 'EXPIRED',
  'INVALIDO': 'INVALID',
  'Nenhuma conta conectada': 'No accounts connected',
  'Vincule uma conta do Instagram ou Facebook para comecar a usar as automacoes.': 'Connect an Instagram or Facebook account to start using automations.',
  'Nenhuma conta encontrada': 'No accounts found',
  'limpar': 'clear',
  'Sem tag': 'No tag',
  'Ativo': 'Active',
  'Inativo': 'Inactive',
  'Configurar': 'Settings',
  'Desconectar conta': 'Disconnect account',
  'Erro ao verificar tokens': 'Error checking tokens',
  'Erro ao desconectar': 'Error disconnecting',
  'Buscar por nome, @usuario ou #tag...': 'Search by name, @username or #tag...',

  // === DASHBOARD ACCOUNT CARD ===
  'Erro ao salvar tag': 'Error saving tag',
  'Erro ao remover tag': 'Error removing tag',
  'Nenhum fluxo configurado': 'No flow configured',
  'Use um template pronto': 'Use a ready template',
  'Template': 'Template',
  'Templates': 'Templates',
  'Exportar': 'Export',

  // === TEMPLATE GALLERY ===
  'Templates de Fluxo': 'Flow Templates',
  'Exportar atual': 'Export current',
  'Importar JSON': 'Import JSON',
  'Todos': 'All',
  'Auto-resposta': 'Auto-reply',
  'Fluxo Instagram:': 'Instagram Flow:',
  'Auto-comentario:': 'Auto-comment:',
  'Aplicando...': 'Applying...',
  'Aplicar nesta conta': 'Apply to this account',
  'Aplicar': 'Apply',
  'na conta': 'to account',
  'Isso vai substituir o fluxo atual.': 'This will replace the current flow.',
  'aplicado!': 'applied!',
  'Erro ao aplicar': 'Error applying',
  'Fluxo IG': 'IG Flow',
  'Fluxo FB': 'FB Flow',
  'Template exportado': 'Template exported',
  'Template exportado!': 'Template exported!',
  'Arquivo nao parece ser um template valido': 'File does not appear to be a valid template',
  'Erro ao ler arquivo JSON': 'Error reading JSON file',

  // === INSTAGRAM FLOW ===
  'Auto-resposta Instagram': 'Instagram Auto-Reply',
  'Respondendo automaticamente': 'Replying automatically',
  'Desativado': 'Disabled',
  'ATIVO': 'ACTIVE',
  'INATIVO': 'INACTIVE',
  'Mensagens do Fluxo': 'Flow Messages',
  'passo': 'step',
  'passos': 'steps',
  'Digite a mensagem...': 'Type your message...',
  'Enviando...': 'Sending...',
  'Imagem': 'Image',
  'Adicionar passo': 'Add step',
  'Botao CTA (opcional)': 'CTA Button (optional)',
  'Texto do botao': 'Button text',
  'Salvando...': 'Saving...',
  'Salvar Fluxo Instagram': 'Save Instagram Flow',
  'Fluxo Instagram salvo!': 'Instagram flow saved!',
  'Erro ao salvar fluxo': 'Error saving flow',
  'Instagram desativado': 'Instagram disabled',
  'Instagram ativado!': 'Instagram enabled!',
  'Imagem enviada!': 'Image uploaded!',
  'Erro no upload': 'Upload error',
  'Ex: Saiba mais': 'E.g.: Learn more',

  // === FACEBOOK FLOW ===
  'Auto-resposta Facebook': 'Facebook Auto-Reply',
  'Salvar Fluxo Facebook': 'Save Facebook Flow',
  'Fluxo Facebook salvo!': 'Facebook flow saved!',
  'Facebook desativado': 'Facebook disabled',
  'Facebook ativado!': 'Facebook enabled!',
  'Solicita permissao para enviar mensagem futura': 'Requests permission to send future messages',
  'Texto do prompt OTN': 'OTN prompt text',
  'Ex: Quer receber uma oferta exclusiva?': 'E.g.: Want to receive an exclusive offer?',

  // === AUTOMATION TAB ===
  'Auto-Comentario': 'Auto-Comment',
  'Responde automaticamente a comentarios': 'Automatically replies to comments',
  'Texto da resposta': 'Reply text',
  'Ative para configurar': 'Enable to configure',
  'Moderacao': 'Moderation',
  'Oculta comentarios com palavras bloqueadas': 'Hides comments with blocked words',
  'Palavras bloqueadas': 'Blocked words',
  'Adicionar palavra...': 'Add word...',
  'Nenhuma palavra adicionada': 'No words added',
  'Resposta Privada': 'Private Reply',
  'Envia DM automatica via Messenger quando alguem comenta': 'Sends automatic DM via Messenger when someone comments',
  'Mensagem da resposta privada': 'Private reply message',
  'Salvar Automacao': 'Save Automation',
  'Automacao Instagram salva!': 'Instagram automation saved!',
  'Automacao Facebook salva!': 'Facebook automation saved!',
  'Erro ao salvar': 'Error saving',
  'Obrigado pelo comentario! Confira nosso inbox...': 'Thanks for the comment! Check our inbox...',
  'Oi {{nome}}! Vi que voce comentou no nosso post. Confira essa novidade...': 'Hi {{nome}}! I saw you commented on our post. Check this out...',
  'Janela de 7 dias': '7-day window',
  'A Private Reply API permite enviar DM em resposta a comentarios com janela de 7 dias (sem limite de 24h). Aparece no Messenger com banner "respondendo ao seu comentario".': 'The Private Reply API allows sending a direct message in response to public comments within a 7-day window. Appears in Messenger with a "replying to your comment" banner.',

  // === KEYWORDS TAB ===
  'Nome do fluxo': 'Flow name',
  'Keywords (separadas por virgula)': 'Keywords (comma-separated)',
  'Mensagens': 'Messages',
  'Adicionar msg': 'Add message',
  'Criando...': 'Creating...',
  'Criar Fluxo': 'Create Flow',
  'fluxo': 'flow',
  'fluxos': 'flows',
  'Novo Fluxo de Keyword': 'New Keyword Flow',
  'Nenhum fluxo de keyword': 'No keyword flows',
  'Crie fluxos para responder automaticamente baseado em palavras-chave': 'Create flows to auto-reply based on keywords',
  'Fluxo de keyword criado!': 'Keyword flow created!',
  'Erro ao criar fluxo': 'Error creating flow',
  'Fluxo excluido!': 'Flow deleted!',
  'Erro ao excluir': 'Error deleting',
  'Ex: Promo Black Friday': 'E.g.: Black Friday Promo',
  'promo, desconto, oferta': 'promo, discount, offer',
  'Novo Fluxo': 'New Flow',
  'Mensagem...': 'Message...',

  // === MENU OTN TAB ===
  'Perfis Vinculados': 'Linked Profiles',
  'Nenhum perfil vinculado': 'No profiles linked',
  'Redundante': 'Redundant',
  'Sem redundancia': 'No redundancy',
  'Sem token': 'No token',
  'Valido': 'Valid',
  'Invalido': 'Invalid',
  'Adicionar perfil': 'Add profile',
  'Keep-Alive': 'Keep-Alive',
  'Envia mensagem automatica antes da janela de 24h expirar': 'Send a follow-up message to engaged contacts',
  'Mensagem de keep-alive': 'Keep-alive message',
  'Salvar Keep-Alive': 'Save Keep-Alive',
  'Menu Persistente': 'Persistent Menu',
  'Botoes fixos que aparecem no Messenger (max 3)': 'Fixed buttons that appear in Messenger (max 3)',
  'Titulo do botao': 'Button title',
  'Adicionar item': 'Add item',
  'Salvar Menu': 'Save Menu',
  'Disparar OTN': 'Send Notification',
  'Envie mensagem unica para quem autorizou': 'Send a one-time message to authorized users',
  'Carregando...': 'Loading...',
  'Ver Stats': 'View Stats',
  'Total tokens': 'Total tokens',
  'Disponiveis': 'Available',
  'Mensagem OTN': 'OTN Message',
  'Menu persistente salvo!': 'Persistent menu saved!',
  'Erro ao salvar menu': 'Error saving menu',
  'Erro ao carregar stats OTN': 'Error loading OTN stats',
  'Digite a mensagem OTN': 'Enter OTN message',
  'Erro ao enviar OTN': 'Error sending OTN',
  'Keep-Alive salvo!': 'Keep-Alive saved!',
  'Erro ao salvar Keep-Alive': 'Error saving Keep-Alive',
  'Recomendamos vincular pelo menos 2 perfis para redundancia. Se um perfil cair, o sistema usa automaticamente o outro.': 'We recommend linking at least 2 profiles for redundancy. If one profile goes down, the system automatically uses the other.',
  'Enviada automaticamente quando o contato esta entre 22-23h...': 'Follows up with recently engaged contacts...',
  'perfil(is) ativo(s)': 'active profile(s)',
  'Adicionado em': 'Added on',
  'Remover o token do perfil': 'Remove token for profile',
  'Token de': 'Token for',
  'removido': 'removed',
  'Erro ao remover token': 'Error removing token',
  'Oi! Tudo bem? Me responde aqui rapidinho...': 'Hey! How are you? Reply quickly here...',
  'Enviada automaticamente quando o contato esta entre 22-23h sem interagir. Se ele responder, a janela reseta por +24h.': 'Sends a follow-up message to contacts who have engaged recently. If they reply, the conversation stays active.',
  'A cada 10 min, verifica contatos FB prestes a perder a janela (22-23h)': 'Periodically checks contact engagement status',
  'Envia a mensagem com': 'Sends the message with',
  'botoes clicaveis': 'clickable buttons',
  'O contato so precisa': 'The contact only needs to',
  'tocar num botao': 'tap a button',
  'pra resetar a janela +24h': 'to reset the window +24h',
  'Maximo 1 keep-alive por contato a cada 24h': 'Maximum 1 keep-alive per contact every 24h',
  'Respeita o toggle de auto-reply por conversa': 'Respects the auto-reply toggle per conversation',
  'Digite a mensagem que sera enviada...': 'Type the message to be sent...',
  'enviado': 'sent',

  // === CHAT ===
  'Conversas': 'Conversations',
  'chats': 'chats',
  'Buscar contato...': 'Search contact...',
  'Nenhum resultado': 'No results',
  'Nenhuma conversa': 'No conversations',
  'Desconhecido': 'Unknown',
  'agora': 'now',
  'Sem mensagens': 'No messages',
  'Voce: ': 'You: ',
  'Selecione uma conversa': 'Select a conversation',
  'Escolha um contato na lista ao lado para ver as mensagens': 'Choose a contact from the list to view messages',
  'Pedir OTN': 'Request OTN',
  'Envia pedido de opt-in para notificacao futura': 'Sends opt-in request for future notification',
  'Digite uma mensagem...': 'Type a message...',
  'Hoje': 'Today',
  'Ontem': 'Yesterday',
  'Erro ao enviar mensagem': 'Error sending message',
  'Erro ao alterar auto-reply': 'Error changing auto-reply',
  'Pedido de OTN enviado!': 'OTN request sent!',
  'Erro ao enviar pedido de OTN': 'Error sending OTN request',
  'Erro ao enviar': 'Error sending',
  'Disparo Direto': 'Direct Send',
  'Pagina': 'Page',
  'Selecione a pagina': 'Select the page',
  'selecionados': 'selected',
  'Limpar': 'Clear',
  'Nenhum contato encontrado': 'No contacts found',
  'Mensagem': 'Message',
  'Botao com link (opcional)': 'Link button (optional)',
  'Enviar para': 'Send to',
  'contato(s)': 'contact(s)',
  'nome': 'name',
  '1o nome': 'first name',
  'Bom dia/tarde': 'Good morning/afternoon',
  'Ola {{nome}}, tudo bem? Confira nossa *promocao*!': 'Hi {{nome}}, how are you? Check out our *promotion*!',

  // === CONTACTS ===
  'Outro': 'Other',
  'Gerencie sua base de contatos': 'Manage your contact base',
  'Importar': 'Import',
  'Importar Contatos': 'Import Contacts',
  'Importacao concluida!': 'Import complete!',
  'paginas processadas': 'pages processed',
  'Importando contatos...': 'Importing contacts...',
  'Novos': 'New',
  'Atualizados': 'Updated',
  'Ja existentes': 'Already existing',
  'ja existentes': 'already existing',
  'Paginas API': 'API Pages',
  'Fechar': 'Close',
  'Importa contatos das conversas do Messenger via API do Meta.': 'Imports contacts from Messenger conversations via Meta API.',
  'Selecione a pagina...': 'Select the page...',
  'Periodo': 'Period',
  'Todo o periodo': 'All time',
  'Limite': 'Limit',
  'Importar todo o periodo pode levar alguns minutos...': 'Importing all time may take a few minutes...',
  'Limpar importados': 'Clear imported',
  'Limpar todos': 'Clear all',
  'Total de contatos': 'Total contacts',
  'Dentro da janela 24h': 'Within 24h window',
  'Importados': 'Imported',
  'Buscar por nome...': 'Search by name...',
  'Todas origens': 'All sources',
  'Dentro 24h': 'Within 24h',
  'Fora 24h': 'Outside 24h',
  'Todas paginas': 'All pages',
  'resultado(s)': 'result(s)',
  'Nome': 'Name',
  'Origem': 'Source',
  'Ultima vez': 'Last seen',
  'Msgs': 'Msgs',
  'Janela': 'Window',
  'Tags': 'Tags',
  '24h': '24h',
  'Fora': 'Outside',
  'Por pagina:': 'Per page:',
  'Selecione uma pagina': 'Select a page',
  'Erro ao importar contatos': 'Error importing contacts',
  'Importado!': 'Imported!',
  'novos': 'new',
  'atualizados': 'updated',

  // === BROADCAST ===
  'Broadcast': 'Broadcast',
  'Envie mensagens em massa para seus contatos': 'Send messages to your opted-in contacts',
  'Enviando broadcast...': 'Sending broadcast...',
  'Enviados': 'Sent',
  'Falhas': 'Failed',
  'Ignorados': 'Skipped',
  'Via Tag': 'Via Tag',
  'concluido': 'completed',
  'Via Message Tag': 'Via Message Tag',
  'Configuracao': 'Configuration',
  'Desmarcar todas': 'Deselect all',
  'Selecionar todas': 'Select all',
  'contatos total': 'total contacts',
  'em 24h': 'in 24h',
  'Conta': 'Account',
  'Selecione uma conta...': 'Select an account...',
  'Filtro de audiencia': 'Audience filter',
  'Todos os contatos': 'All contacts',
  'Apenas dentro de 24h': 'Only within 24h',
  'Por tag': 'By tag',
  'Nome da tag': 'Tag name',
  'Alcance (somente FB)': 'Reach (FB only)',
  'Padrao (janela de 24h)': 'Default (24h window)',
  'Alcance Maximo': 'Maximum Reach',
  'Template rapido (opcional)': 'Quick template (optional)',
  'Texto da mensagem': 'Message text',
  'Bom dia/tarde/noite': 'Good morning/afternoon/evening',
  'quinta-feira': 'Thursday',
  'Botoes (opcional, max 3)': 'Buttons (optional, max 3)',
  '+ Adicionar botao': '+ Add button',
  'Resposta automatica': 'Auto-reply',
  'Imagem (opcional)': 'Image (optional)',
  'Filtro play': 'Play filter',
  'Clique para enviar uma imagem': 'Click to upload an image',
  'Preview (Messenger):': 'Preview (Messenger):',
  'Enviar Broadcast': 'Send Broadcast',
  'Contas selecionadas': 'Selected accounts',
  'Total contatos': 'Total contacts',
  'Janela 24h': 'Window 24h',
  'Resumo da conta': 'Account summary',
  'Total': 'Total',
  'Variaveis e formatacao': 'Variables & formatting',
  'Nome completo': 'Full name',
  'Primeiro nome': 'First name',
  'Bom dia / Boa tarde / Boa noite': 'Good morning / Good afternoon / Good evening',
  'Hora do envio (14:32)': 'Send time (14:32)',
  'Dia da semana (quinta-feira)': 'Day of week (Thursday)',
  'Data (20/02/2026)': 'Date (02/20/2026)',
  'Sobre Message Tags': 'About Message Tags',
  'Message Tags permitem enviar mensagens fora da janela de 24h no Facebook Messenger.': 'Message Tags allow sending messages outside the 24h window on Facebook Messenger.',
  'Usar tags incorretamente pode resultar em restricao da conta pelo Meta.': 'Using tags incorrectly may result in account restriction by Meta.',
  'Evento': 'Event',
  'Atualizacoes de eventos confirmados': 'Confirmed event updates',
  'Compra': 'Purchase',
  'Atualizacoes pos-compra': 'Post-purchase updates',
  'Notificacoes sobre a conta do usuario': 'User account notifications',
  'Resposta Humana': 'Human Agent',
  'Janela de 7 dias (nao 24h)': '7-day window (not 24h)',
  'Historico de Broadcasts': 'Broadcast History',
  'Nenhum broadcast enviado ainda': 'No broadcasts sent yet',
  'Os broadcasts enviados aparecerão aqui': 'Sent broadcasts will appear here',
  'Data/Hora': 'Date/Time',
  'Contas': 'Accounts',
  'Acoes': 'Actions',
  'Com imagem': 'With image',
  'Anterior': 'Previous',
  'Proximo': 'Next',
  'Selecione pelo menos uma conta': 'Select at least one account',
  'Selecione uma conta': 'Select an account',
  'Digite a mensagem': 'Type the message',
  'Broadcast concluido!': 'Broadcast completed!',
  'Imagem enviada com filtro!': 'Image uploaded with filter!',
  'Erro ao iniciar broadcast': 'Error starting broadcast',
  'Erro ao enviar broadcast': 'Error sending broadcast',
  'contatos': 'contacts',
  'Registro excluido': 'Record deleted',

  // === BROADCAST TEMPLATES ===
  'Ligacao de video': 'Video Call',
  'Chamada perdida': 'Missed Call',
  'Mensagem de voz': 'Voice Message',
  'Notificacao pendente': 'Pending Notification',
  'Presente pra voce': 'Gift for You',
  'Ultimo aviso': 'Final Notice',
  'Alguem te mencionou': 'Someone Mentioned You',
  'Conteudo exclusivo': 'Exclusive Content',

  // === RECUPERAR COMENTARIOS ===
  'Selecione a pagina para varrer todos os comentarios': 'Select the page to retrieve recent commenters',
  'Carregando paginas...': 'Loading pages...',
  'Nenhuma pagina FB conectada': 'No FB pages connected',
  'Conecte uma pagina Facebook com automacao FB ativa': 'Connect a Facebook page with active FB automation',
  'Pagina Facebook': 'Facebook Page',
  'Voltar': 'Back',
  'Comentarios dos ultimos 7 dias': 'Comments from the last 7 days',
  'Atualizar': 'Refresh',
  'Varrendo comentarios...': 'Retrieving comments...',
  'Comentadores': 'Commenters',
  'Posts varridos': 'Posts retrieved',
  'Nenhum comentador encontrado': 'No commenters found',
  'Nenhum comentario nos ultimos 7 dias nesta pagina': 'No comments in the last 7 days on this page',
  'unicos': 'unique',
  'Template rapido': 'Quick template',
  'Clique para adicionar imagem': 'Click to add image',
  'Recuperar': 'Recover',
  'Como funciona': 'How it works',
  'Variaveis': 'Variables',
  'Erro ao carregar paginas': 'Error loading pages',
  'Erro ao carregar comentadores': 'Error loading commenters',
  'Imagem carregada': 'Image loaded',
  'Erro ao enviar imagem': 'Error uploading image',
  'Nenhum comentador encontrado.': 'No commenters found.',
  'Enviando private replies...': 'Sending private replies...',
  'Enviar Private Reply para': 'Send Private Reply to',
  'comentadores': 'commenters',
  'Comentadores (ultimos 7 dias)': 'Commenters (last 7 days)',
  'Comentadores (todos)': 'Commenters (all)',
  'Salva como contatos': 'Saves as contacts',
  'Enviando para comentadores...': 'Sending to commenters...',
  'Enviar': 'Send',
  'para': 'to',
  'falhas': 'failures',
  'Concluido!': 'Completed!',
  'Erro ao iniciar envio': 'Error starting send',
  'Buscando todos os posts e comentadores de': 'Retrieving recent posts and commenters from',
  'Varre todos os posts desta pagina e envia DM para cada comentador unico.': 'Retrieves post commenters and sends authorized private replies.',
  'Sem limite 24h': 'Extended messaging window',
  'Bypassa a janela de 24h': 'Uses Private Reply API (7-day window)',
  '1 por usuario': '1 per user',
  'Deduplicado por comentador': 'Deduplicated per commenter',
  'Oi {{nome}}! Vi que voce comentou no nosso post...': 'Hi {{nome}}! I saw you commented on our post...',

  // === RECUPERAR COMENTARIOS TEMPLATES ===
  'Vi seu comentario': 'Saw Your Comment',
  'Novidade': 'News',
  'Oferta especial': 'Special Offer',
  'Agradecimento': 'Thank You',
  'Urgencia': 'Urgency',

  // === ADMIN ===
  'Painel administrativo do sistema': 'System administration panel',
  'Novo Cliente': 'New Client',
  'Nome do cliente': 'Client name',
  'Senha (min 6 chars)': 'Password (min 6 chars)',
  'Criar Cliente': 'Create Client',
  'Clientes': 'Clients',
  'Contas totais': 'Total accounts',
  'IG Ativas': 'IG Active',
  'FB Ativas': 'FB Active',
  'DMs IG (7d)': 'IG DMs (7d)',
  'DMs FB (7d)': 'FB DMs (7d)',
  'OTN Disponiveis': 'OTN Available',
  'Acao': 'Action',
  'Nenhum cliente cadastrado': 'No clients registered',
  'Preencha todos os campos': 'Fill in all fields',
  'Senha deve ter no minimo 6 caracteres': 'Password must be at least 6 characters',
  'Cliente criado!': 'Client created!',
  'Erro ao criar': 'Error creating',
  'Cliente excluido!': 'Client deleted!',

  // === MONITOR ===
  'Atividade do sistema em tempo real (atualiza a cada 3s)': 'Real-time system activity (refreshes every 3s)',
  'entradas': 'entries',
  'Nenhuma atividade registrada': 'No activity recorded',
  'Info': 'Info',

  // === SEQUENCES ===
  'Drip campaigns - mensagens agendadas com delay em dias': 'Automated sequences - scheduled follow-up messages',
  'Nova Sequencia': 'New Sequence',
  'Selecione...': 'Select...',
  'Plataforma': 'Platform',
  'Passos (max 5)': 'Steps (max 5)',
  'dias': 'days',
  'Criar Sequencia': 'Create Sequence',
  'Nenhuma sequencia': 'No sequences',
  'Crie campanhas drip com mensagens agendadas por dias de delay.': 'Create automated sequences with scheduled follow-up messages.',
  'Imediato': 'Immediate',
  'dia(s)': 'day(s)',
  'Inscrever contatos': 'Enroll contacts',
  'Excluir': 'Delete',
  'Sequencia criada!': 'Sequence created!',
  'Sequencia excluida!': 'Sequence deleted!',
  'Erro ao inscrever': 'Error enrolling',
  'contatos inscritos!': 'contacts enrolled!',
  'Adicione pelo menos uma mensagem': 'Add at least one message',
  'Digite um nome': 'Enter a name',

  // === CHECKER BOT ===
  'Clique': 'Click',
  'Espera': 'Wait',
  'Quantidade': 'Amount',
  'Delay (seg)': 'Delay (sec)',
  'Seletor CSS': 'CSS Selector',
  'Descricao (opcional)': 'Description (optional)',
  'Segundos': 'Seconds',
  'Informe o nome do roteiro': 'Enter script name',
  'Informe a URL': 'Enter the URL',
  'Adicione pelo menos um passo': 'Add at least one step',
  'Roteiro atualizado!': 'Script updated!',
  'Roteiro criado!': 'Script created!',
  'Editar Roteiro': 'Edit Script',
  'Novo Roteiro': 'New Script',
  'Monte o roteiro de acoes que a extensao vai executar.': 'Build the action script the extension will execute.',
  'Nome do roteiro': 'Script name',
  'URL da pagina': 'Page URL',
  'Passos': 'Steps',
  'Adicionar Passo': 'Add Step',
  'Nenhum passo adicionado. Clique em "+ Adicionar Passo" acima.': 'No steps added. Click "+ Add Step" above.',
  'Cancelar': 'Cancel',
  'Salvar': 'Save',
  'Roteiro copiado! Cole na extensao com "Importar Roteiro".': 'Script copied! Paste in extension with "Import Script".',
  'scroll': 'scroll',
  'clique': 'click',
  'espera': 'wait',
  'Editar': 'Edit',
  'Copiar pro Extension': 'Copy to Extension',
  'Roteiro deletado': 'Script deleted',
  'Monte roteiros de checagem e exporte pra extensao': 'Build check scripts and export to extension',
  'Baixar Extensao': 'Download Extension',
  'Nenhum roteiro': 'No scripts',
  'Crie seu primeiro roteiro de checagem para exportar pra extensao Chrome.': 'Create your first check script to export to Chrome extension.',
  'Como usar': 'How to use',
  'Crie o roteiro': 'Create the script',
  'Monte os passos: scroll, clique em seletores CSS, esperas entre acoes.': 'Build steps: scroll, click CSS selectors, waits between actions.',
  'Copie o JSON': 'Copy the JSON',
  'Clique em "Copiar pro Extension" pra copiar o roteiro pra area de transferencia.': 'Click "Copy to Extension" to copy the script to clipboard.',
  'Importe na extensao': 'Import in extension',
  'Na extensao, clique em "Importar Roteiro" e cole o JSON copiado.': 'In the extension, click "Import Script" and paste the copied JSON.',
  'Execute': 'Run',
  'Selecione o roteiro e clique Executar. A extensao faz tudo automaticamente.': 'Select the script and click Run. The extension does everything automatically.',

  // === FINANCIAL ===
  'Controle Financeiro': 'Financial Control',
  'Receitas, despesas e balanco da operacao': 'Revenue, expenses and operation balance',
  'Novo Lancamento': 'New Entry',
  'Receita Mensal': 'Monthly Revenue',
  'Despesas Mensais': 'Monthly Expenses',
  'Saldo Mensal': 'Monthly Balance',
  'Total Geral': 'Grand Total',
  'Receita vs Despesa (6 meses)': 'Revenue vs Expense (6 months)',
  'Por Categoria (mes atual)': 'By Category (current month)',
  'Receitas': 'Revenue',
  'Despesas': 'Expenses',
  'Sem dados': 'No data',
  'Lancamentos': 'Entries',
  'Nenhum lancamento encontrado.': 'No entries found.',
  'Data': 'Date',
  'Tipo': 'Type',
  'Categoria': 'Category',
  'Descricao': 'Description',
  'Valor': 'Amount',
  'Receita': 'Revenue',
  'Despesa': 'Expense',
  'Editar Lancamento': 'Edit Entry',
  'Registre uma receita ou despesa da operacao.': 'Register a revenue or expense for the operation.',
  'Valor (R$)': 'Amount (R$)',
  'Pagina (opcional)': 'Page (optional)',
  'Geral (sem pagina)': 'General (no page)',
  'Selecione a categoria': 'Select category',
  'Informe um valor valido': 'Enter a valid amount',
  'Informe a data': 'Enter the date',
  'Lancamento atualizado!': 'Entry updated!',
  'Lancamento criado!': 'Entry created!',
  'Lancamento deletado': 'Entry deleted',
  // Category labels
  'Pagina (Ad Revenue)': 'Page (Ad Revenue)',
  'Cifras': 'Digits',
  'Grupo': 'Group',
  'Compra de Pagina': 'Advertising',
  'Compra de Perfil': 'Marketing',
  'Perfil': 'Profile',

  // === PAGES ===
  'Gerenciamento de Paginas': 'Page Management',
  'Acompanhe suas paginas do Facebook': 'Track your Facebook pages',
  'Importando...': 'Importing...',
  'Importar das Contas': 'Import from Accounts',
  'Nova Pagina': 'New Page',
  'Monetizadas': 'Monetized',
  'Seguidores': 'Followers',
  'Balanco Total': 'Total Balance',
  'Nenhuma pagina': 'No pages',
  'Monetizada': 'Monetized',
  'Nao monetizada': 'Not monetized',
  'seguidores': 'followers',
  'videos': 'videos',
  'Videos': 'Videos',
  'Editar Pagina': 'Edit Page',
  'Cadastre uma pagina do Facebook para acompanhamento.': 'Register a Facebook page for tracking.',
  'Nome da pagina': 'Page name',
  'Link da pagina': 'Page link',
  'Access Token (pra sincronizar videos)': 'Access Token (to sync videos)',
  'Token ja salvo (deixe vazio pra manter)': 'Token already saved (leave empty to keep)',
  'Cole o token da pagina...': 'Paste the page token...',
  'Esta pagina gera receita de anuncios?': 'Does this page generate ad revenue?',
  'Responsavel': 'Responsible',
  'Nome da pessoa responsavel': 'Name of responsible person',
  'Observacoes': 'Notes',
  'Anotacoes sobre a pagina...': 'Notes about the page...',
  'Adicione um access token primeiro': 'Add an access token first',
  'videos sincronizados!': 'videos synced!',
  'Sincronizando...': 'Syncing...',
  'Sincronizar': 'Sync',
  'Nenhum video. Clique em Sincronizar.': 'No videos. Click Sync.',
  'Adicione um access token pra sincronizar.': 'Add an access token to sync.',
  'Sem titulo': 'No title',
  'Informe o nome da pagina': 'Enter page name',
  'Pagina atualizada!': 'Page updated!',
  'Pagina criada!': 'Page created!',
  'Pagina deletada': 'Page deleted',
  'Nenhuma conta conectada encontrada': 'No connected account found',
  'importada(s)': 'imported',
  'atualizada(s)': 'updated',
  'Cadastre suas paginas do Facebook para acompanhar monetizacao, seguidores e balanco.': 'Register your Facebook pages to track monetization, followers and balance.',
  'Titulo': 'Title',
  'Views': 'Views',
  'Ex: Reality Shows Brasil': 'E.g.: Reality Shows Brasil',
  'Ex: Receita de anuncios janeiro, Pagamento grupo X...': 'E.g.: Ad revenue January, Group X payment...',

  // === CTM ===
  'Nunca': 'Never',
  'Agora': 'Now',
  'Links + saudacao + botoes para reativar a janela de 24h': 'Messenger links, greeting text and quick-reply buttons via Messenger Profile API',
  'Nova Campanha': 'New Campaign',
  'Nova Campanha CTM': 'New CTM Campaign',
  'Nome da campanha': 'Campaign name',
  'Ref (identificador no link)': 'Ref (link identifier)',
  'Mensagem de boas-vindas (opcional)': 'Welcome message (optional)',
  'Preview do link:': 'Link preview:',
  'Criar Campanha': 'Create Campaign',
  'Campanhas ativas': 'Active campaigns',
  'Total de cliques': 'Total clicks',
  'Configuracao do Messenger': 'Messenger Configuration',
  'Saudacao:': 'Greeting:',
  'Botao "Comecar"': '"Get Started" Button',
  'Opcoes rapidas (Ice Breakers)': 'Quick Options (Ice Breakers)',
  'Adicionar': 'Add',
  'Preview do Messenger': 'Messenger Preview',
  'Comecar': 'Get Started',
  'Campanha criada!': 'Campaign created!',
  'Erro ao criar campanha': 'Error creating campaign',
  'Campanha deletada': 'Campaign deleted',
  'Erro ao deletar': 'Error deleting',
  'Link copiado!': 'Link copied!',
  'Messenger Profile salvo!': 'Messenger Profile saved!',
  'Mensagem automatica quando alguem clicar no link...': 'Automatic message when someone clicks the link...',
  'Saudacao + botao "Comecar" + opcoes rapidas que aparecem quando alguem abre o chat': 'Greeting + "Get Started" button + quick options that appear when someone opens the chat',
  'Configure a mensagem de boas-vindas diretamente no Facebook em': 'Configure the welcome message directly on Facebook at',
  'Pagina → Configuracoes → Mensagens → Saudacao do Messenger': 'Page → Settings → Messages → Messenger Greeting',
  'Quando a pessoa clica "Comecar", envia esse payload e abre a janela de 24h automaticamente.': 'When the person clicks "Get Started", it sends this payload and opens the 24h window automatically.',
  'Opcao': 'Option',
  'Quero saber mais': 'I want to know more',
  'Botoes que aparecem no chat. A pessoa clica e ja abre a janela sem precisar digitar.': 'Buttons that appear in the chat. The person clicks and opens the window without needing to type.',
  'Configure a saudacao + botoes e crie um link': 'Configure the greeting + buttons and create a link',
  'Compartilhe o link (posts, stories, bio, ads, WhatsApp)': 'Share the link (posts, stories, bio, ads, WhatsApp)',
  'Pessoa clica no botao': 'Person clicks the button',
  'janela de 24h ativa': '24h window active',
  'pode enviar disparos': 'can send broadcasts',
  'Clique em "Nova Campanha" para comecar': 'Click "New Campaign" to get started',
  'Como funciona?': 'How does it work?',
  'Campanha': 'Campaign',
  'Cliques': 'Clicks',
  'Ultimo clique': 'Last click',
  'Nenhuma campanha criada': 'No campaigns created',
  'Link direto da pagina': 'Direct page link',
  'Sem rastreamento de campanha': 'No campaign tracking',
  'Copiar': 'Copy',

  // === VISUAL FLOWS ===
  'Ambos': 'Both',
  'Automacoes drag-and-drop com editor visual': 'Drag-and-drop automations with visual editor',
  'Novo Vazio': 'New Empty',
  'Novo Fluxo Visual': 'New Visual Flow',
  'Ambos (IG + FB)': 'Both (IG + FB)',
  'Somente Instagram': 'Instagram Only',
  'Somente Facebook': 'Facebook Only',
  'Comece com um template pronto!': 'Start with a ready template!',
  'Escolha entre 7 templates profissionais ou importe um script JSON': 'Choose from 7 professional templates or import a JSON script',
  'Ver Templates': 'View Templates',
  'Nenhum fluxo visual': 'No visual flows',
  'Crie fluxos drag-and-drop para automatizar respostas com logica avancada.': 'Create drag-and-drop flows to automate responses with advanced logic.',
  'Criar Fluxo Vazio': 'Create Empty Flow',
  'Fluxo criado!': 'Flow created!',
  'Erro ao alternar': 'Error toggling',
  'Erro ao exportar fluxo': 'Error exporting flow',
  'Criado em': 'Created on',

  // === INPUT FLOWS ===
  'Bots de perguntas que coletam dados dos contatos': 'Interactive forms that collect user responses',
  'Novo Flow': 'New Flow',
  'Novo Input Flow': 'New Input Flow',
  'Keywords de gatilho (virgula)': 'Trigger keywords (comma)',
  'Perguntas (max 5)': 'Questions (max 5)',
  'Adicionar pergunta': 'Add question',
  'Mensagem de conclusao': 'Completion message',
  'Criar Input Flow': 'Create Input Flow',
  'Nenhum Input Flow': 'No Input Flows',
  'Crie bots de perguntas para coletar dados automaticamente via DM.': 'Create interactive forms to collect responses via direct messages.',
  'Criar Flow': 'Create Flow',
  'Input Flow criado!': 'Input Flow created!',
  'pergunta': 'question',
  'perguntas': 'questions',
  'Excluido!': 'Deleted!',
  'Adicione keywords': 'Add keywords',
  'Adicione pelo menos uma pergunta': 'Add at least one question',
  'Obrigado pelas respostas!': 'Thank you for your answers!',
  'cadastro, registro, quero': 'signup, register, want',
  'Pergunta': 'Question',

  // === POSTER ===
  'Gerencie e agende publicacoes para varias paginas': 'Manage and schedule posts for multiple pages',
  'Limpando...': 'Clearing...',
  'Limpar Agendados': 'Clear Scheduled',
  'agendamento(s) de': 'schedule(s) from',
  'Novo Post': 'New Post',
  'Total de posts': 'Total posts',
  'Agendados': 'Scheduled',
  'Publicados': 'Published',
  'Com falha': 'Failed',
  'Calendario': 'Calendar',
  'Lista': 'List',
  'Biblioteca': 'Library',
  'Editar Post': 'Edit Post',
  'Post atualizado!': 'Post updated!',
  'Erro ao atualizar': 'Error updating',
  'Salvar Alteracoes': 'Save Changes',
  'Agendar para': 'Schedule for',
  'URL da imagem': 'Image URL',
  'programacao(oes) removida(s)': 'schedule(s) removed',
  'Erro ao limpar programacoes': 'Error clearing schedules',

  // === STORAGE ===
  'usado': 'used',
  'livres': 'free',
  'Ilimitado': 'Unlimited',
  'Comprar espaco': 'Buy storage',
  'Comprar mais espaco': 'Buy more storage',
  'Fechar': 'Close',
  'O espaco e adicionado automaticamente apos o pagamento': 'Storage is added automatically after payment',
  'Cobranca gerada! Complete o pagamento via PIX.': 'Invoice created! Complete the payment via PIX.',
  'Erro ao gerar cobranca': 'Error creating invoice',

  // === MEDIA ===
  'Gerencie suas imagens e videos, e corte videos em clips': 'Manage your images and videos, and cut videos into clips',
  'Corte de Video': 'Video Cutting',
  'Selecione uma pasta para ver o conteudo': 'Select a folder to view its content',
  'Ou crie uma nova pasta no painel a esquerda': 'Or create a new folder in the left panel',
  'Pastas': 'Folders',
  'Nova pasta': 'New folder',
  'Nome da pasta...': 'Folder name...',
  'Nenhuma pasta': 'No folders',
  'Criar pasta': 'Create folder',
  'Vazia': 'Empty',
  'pasta': 'folder',
  'pastas': 'folders',
  'arquivo': 'file',
  'arquivos': 'files',
  'Pasta criada!': 'Folder created!',
  'Pasta deletada': 'Folder deleted',
  'Deletar pasta': 'Delete folder',
  'Pasta renomeada': 'Folder renamed',

  // === CONFIRM DIALOGS (dynamic - these are templates) ===
  'Desconectar': 'Disconnect',
  'Os dados de fluxo desta conta serao perdidos.': 'The flow data for this account will be lost.',
  'Excluir fluxo': 'Delete flow',
  'Deletar pagina': 'Delete page',
  'Os lancamentos financeiros serao mantidos.': 'Financial entries will be kept.',
  'Deletar este lancamento?': 'Delete this entry?',
  'Tem certeza? Isso vai apagar TODOS os contatos!': 'Are you sure? This will delete ALL contacts!',
  'Apagar somente os contatos importados?': 'Delete only imported contacts?',
  'contatos removidos': 'contacts removed',
  'Erro ao limpar contatos': 'Error clearing contacts',

  // === YOUTUBE DUBBING ===
  'Tradutor': 'Translator',
  'Nova Traducao / Dublagem': 'New Translation / Dubbing',
  'URL do video (YouTube ou outro)': 'Video URL (YouTube or other)',
  'Upload de arquivo': 'File upload',
  'Clique para selecionar video ou audio': 'Click to select video or audio',
  'Idioma de origem': 'Source language',
  'Idioma de destino': 'Target language',
  'Auto-detectar': 'Auto-detect',
  'Portugues': 'Portuguese',
  'Ingles': 'English',
  'Espanhol': 'Spanish',
  'Frances': 'French',
  'Alemao': 'German',
  'Italiano': 'Italian',
  'Japones': 'Japanese',
  'Coreano': 'Korean',
  'Chines': 'Chinese',
  'Russo': 'Russian',
  'Arabe': 'Arabic',
  'Hindi': 'Hindi',
  'Turco': 'Turkish',
  'Traduzir': 'Translate',
  'Historico de Dublagens': 'Dubbing History',
  'Nenhuma dublagem realizada': 'No dubbing jobs yet',
  'Cole uma URL ou envie um video acima para comecar': 'Paste a URL or upload a video above to get started',
  'Processando': 'Processing',
  'Concluido': 'Completed',
  'Dublagem criada!': 'Dubbing created!',
  'Dublagem excluida': 'Dubbing deleted',
  'Cole uma URL ou selecione um arquivo': 'Paste a URL or select a file',

  // === INSTAGRAM PROFILE + MEDIA ===
  'Instagram': 'Instagram',
  'Selecionar conta': 'Select account',
  'Nenhuma conta Instagram conectada': 'No Instagram account connected',
  'Midias Recentes': 'Recent Media',
  'Posts': 'Posts',
  'Seguindo': 'Following',
  'Biografia': 'Biography',

  // === INSTAGRAM COMMENTS ===
  'Comentarios': 'Comments',
  'Nenhum comentario': 'No comments',
  'Escrever comentario...': 'Write a comment...',
  'Comentario adicionado!': 'Comment added!',
  'Erro ao adicionar comentario': 'Error adding comment',
  'Comentario editado!': 'Comment updated!',
  'Erro ao editar comentario': 'Error updating comment',
  'Comentario removido!': 'Comment deleted!',
  'Erro ao remover comentario': 'Error deleting comment',

  // === PAGE ENGAGEMENT ===
  'Engagement': 'Engagement',
  'Engagement da Pagina': 'Page Engagement',
  'Nenhuma pagina conectada': 'No page connected',
  'Selecionar pagina': 'Select page',
  'Curtidas': 'Likes',
  'Compartilhamentos': 'Shares',
  'Nenhum post encontrado': 'No posts found',
  'Nenhum comentario': 'No comments',
  'Escreva um comentario...': 'Write a comment...',
  'Comentario adicionado!': 'Comment added!',
  'Comentario deletado!': 'Comment deleted!',
  'Deletar este comentario?': 'Delete this comment?',
  'Post atualizado!': 'Post updated!',
  'Post deletado!': 'Post deleted!',
  'Deletar este post do Facebook? Essa acao nao pode ser desfeita.': 'Delete this Facebook post? This action cannot be undone.',
  'Salvar': 'Save',
  'Cancelar': 'Cancel',
  'Ocultar comentarios': 'Hide comments',
  'Ver': 'View',
  'Comentar': 'Comment',

  // === INSTAGRAM DM ===
  'Enviar DM Instagram': 'Send Instagram DM',
  'Conta Instagram': 'Instagram Account',
  'ID do Destinatario': 'Recipient ID',
  'Instagram-Scoped User ID': 'Instagram-Scoped User ID',
  'Mensagem Instagram enviada!': 'Instagram message sent!',
  'Erro ao enviar DM': 'Error sending DM',
  'Enviar DM': 'Send DM',
  'Digite sua mensagem...': 'Type your message...',

  // === STATUS PAGE ===
  'Status dos Servicos': 'Service Status',
  'Monitoramento em tempo real de todos os servicos': 'Real-time monitoring of all services',
  'Atualizado': 'Updated',
  'operacionais': 'operational',
  'Todos os servicos estao operacionais': 'All services are operational',
  'Alguns servicos apresentam problemas': 'Some services are experiencing issues',
  'Atualiza automaticamente a cada 15 segundos': 'Auto-refreshes every 15 seconds',
  'Operacional': 'Operational',
  'Degradado': 'Degraded',
  'Manutencao': 'Maintenance',
  'Offline': 'Offline',
  'Status': 'Status',

  // === TRACKER ===
  'Rastreamento': 'Tracking',
  'Rastreie visitantes dos seus sites em tempo real': 'Track visitors on your sites in real time',
  'Dominio': 'Domain',
  'Dominio (ex: meusite.com.br)': 'Domain (e.g.: mysite.com)',
  'Dispositivos': 'Devices',
  'Dispositivo': 'Device',
  'Localizacao': 'Location',
  'Local': 'Location',
  'Historico': 'History',
  'Unicos Hoje': 'Unique Today',

  // === MISC / COMMON ===
  'Passo': 'Step',
  'de': 'of',
  'Selecione': 'Select',
  'enviados': 'sent',
  'falhas': 'failures',
  'Confirma o envio': 'Confirm sending',

  // === SCHEDULE ALERT ===
  'sem videos agendados': 'no scheduled videos',
  'dia restante': 'day remaining',
  'dias restantes': 'days remaining',
}

// Portuguese accent corrections — maps unaccented keys to proper Portuguese
export const ptCorrections: Record<string, string> = {
  // LOGIN
  'Gerencie todas suas automacoes em um so lugar.': 'Gerencie todas suas automações em um só lugar.',
  'Bem-vindo de volta': 'Bem-vindo de volta',
  'Contas ativas': 'Contas ativas',
  'Mensagens enviadas': 'Mensagens enviadas',
  'Entre para gerenciar suas automacoes': 'Entre para gerenciar suas automações',
  'Usuario': 'Usuário',
  'Seu usuario': 'Seu usuário',
  'Usuario ou senha incorretos': 'Usuário ou senha incorretos',
  'Automacao de Instagram e Facebook': 'Automação de Instagram e Facebook',

  // SIDEBAR
  'Recuperar Comentarios': 'Recuperar Comentários',
  'Sequencias': 'Sequências',
  'Midias': 'Mídias',
  'Download Midias': 'Download Mídias',
  'Download de Midias': 'Download de Mídias',
  'Baixe fotos e videos de paginas do Facebook': 'Baixe fotos e vídeos de páginas do Facebook',
  'Paginas conectadas': 'Páginas conectadas',
  'Selecione uma pagina...': 'Selecione uma página...',
  'Buscar Midias': 'Buscar Mídias',
  'Cole a URL da pagina do Facebook. O scraping pode levar alguns minutos.': 'Cole a URL da página do Facebook. O scraping pode levar alguns minutos.',
  'Colar cookies do Facebook (necessario para perfis)': 'Colar cookies do Facebook (necessário para perfis)',
  'Cole aqui os cookies do Facebook (formato JSON do EditThisCookie)...': 'Cole aqui os cookies do Facebook (formato JSON do EditThisCookie)...',
  'Instale a extensao EditThisCookie no Chrome, acesse o Facebook logado, exporte os cookies e cole acima.': 'Instale a extensão EditThisCookie no Chrome, acesse o Facebook logado, exporte os cookies e cole acima.',
  'Facebook exige login para acessar esta pagina': 'Facebook exige login para acessar esta página',
  'Cookies invalidos - cole no formato JSON': 'Cookies inválidos - cole no formato JSON',
  'Cookies salvos sao usados automaticamente': 'Cookies salvos são usados automaticamente',
  'Selecione uma pagina e busque as midias': 'Selecione uma página e busque as mídias',
  'Cole a URL da pagina do Facebook': 'Cole a URL da página do Facebook',
  'Paginas': 'Páginas',
  'Automacao': 'Automação',
  'Conteudo': 'Conteúdo',
  'Gestao': 'Gestão',

  // DASHBOARD
  'validos': 'válidos',
  'invalidos': 'inválidos',
  'Tokens Validos': 'Tokens Válidos',
  'Tokens Invalidos': 'Tokens Inválidos',
  'Expiracao': 'Expiração',
  'VALIDO': 'VÁLIDO',
  'INVALIDO': 'INVÁLIDO',
  'Vincule uma conta do Instagram ou Facebook para comecar a usar as automacoes.': 'Vincule uma conta do Instagram ou Facebook para começar a usar as automações.',
  'Buscar por nome, @usuario ou #tag...': 'Buscar por nome, @usuário ou #tag...',

  // TEMPLATE GALLERY
  'Arquivo nao parece ser um template valido': 'Arquivo não parece ser um template válido',
  'Auto-comentario:': 'Auto-comentário:',
  'Isso vai substituir o fluxo atual.': 'Isso vai substituir o fluxo atual.',

  // INSTAGRAM FLOW
  'Botao CTA (opcional)': 'Botão CTA (opcional)',
  'Texto do botao': 'Texto do botão',

  // FACEBOOK FLOW
  'Solicita permissao para enviar mensagem futura': 'Solicita permissão para enviar mensagem futura',

  // AUTOMATION TAB
  'Auto-Comentario': 'Auto-Comentário',
  'Responde automaticamente a comentarios': 'Responde automaticamente a comentários',
  'Moderacao': 'Moderação',
  'Oculta comentarios com palavras bloqueadas': 'Oculta comentários com palavras bloqueadas',
  'Salvar Automacao': 'Salvar Automação',
  'Automacao Instagram salva!': 'Automação Instagram salva!',
  'Automacao Facebook salva!': 'Automação Facebook salva!',
  'Obrigado pelo comentario! Confira nosso inbox...': 'Obrigado pelo comentário! Confira nosso inbox...',
  'Oi {{nome}}! Vi que voce comentou no nosso post. Confira essa novidade...': 'Oi {{nome}}! Vi que você comentou no nosso post. Confira essa novidade...',
  'Envia DM automatica via Messenger quando alguem comenta': 'Envia DM automática via Messenger quando alguém comenta',
  'A Private Reply API permite enviar DM em resposta a comentarios com janela de 7 dias (sem limite de 24h). Aparece no Messenger com banner "respondendo ao seu comentario".': 'A Private Reply API permite enviar DM em resposta a comentários com janela de 7 dias (sem limite de 24h). Aparece no Messenger com banner "respondendo ao seu comentário".',

  // KEYWORDS TAB
  'Keywords (separadas por virgula)': 'Keywords (separadas por vírgula)',
  'Crie fluxos para responder automaticamente baseado em palavras-chave': 'Crie fluxos para responder automaticamente baseado em palavras-chave',
  'Fluxo excluido!': 'Fluxo excluído!',

  // MENU OTN TAB
  'Sem redundancia': 'Sem redundância',
  'Valido': 'Válido',
  'Invalido': 'Inválido',
  'Envia mensagem automatica antes da janela de 24h expirar': 'Envia mensagem automática antes da janela de 24h expirar',
  'Botoes fixos que aparecem no Messenger (max 3)': 'Botões fixos que aparecem no Messenger (max 3)',
  'Titulo do botao': 'Título do botão',
  'Envie mensagem unica para quem autorizou': 'Envie mensagem única para quem autorizou',
  'Disponiveis': 'Disponíveis',
  'Recomendamos vincular pelo menos 2 perfis para redundancia. Se um perfil cair, o sistema usa automaticamente o outro.': 'Recomendamos vincular pelo menos 2 perfis para redundância. Se um perfil cair, o sistema usa automaticamente o outro.',
  'Enviada automaticamente quando o contato esta entre 22-23h...': 'Enviada automaticamente quando o contato está entre 22-23h...',
  'Enviada automaticamente quando o contato esta entre 22-23h sem interagir. Se ele responder, a janela reseta por +24h.': 'Enviada automaticamente quando o contato está entre 22-23h sem interagir. Se ele responder, a janela reseta por +24h.',
  'Envia a mensagem com': 'Envia a mensagem com',
  'botoes clicaveis': 'botões clicáveis',
  'O contato so precisa': 'O contato só precisa',
  'tocar num botao': 'tocar num botão',
  'Maximo 1 keep-alive por contato a cada 24h': 'Máximo 1 keep-alive por contato a cada 24h',
  'Digite a mensagem que sera enviada...': 'Digite a mensagem que será enviada...',
  'Envia pedido de opt-in para notificacao futura': 'Envia pedido de opt-in para notificação futura',

  // CHAT
  'Voce: ': 'Você: ',
  'Erro ao enviar mensagem': 'Erro ao enviar mensagem',
  'Pagina': 'Página',
  'Selecione a pagina': 'Selecione a página',
  'Botao com link (opcional)': 'Botão com link (opcional)',
  'Ola {{nome}}, tudo bem? Confira nossa *promocao*!': 'Olá {{nome}}, tudo bem? Confira nossa *promoção*!',

  // CONTACTS
  'Importacao concluida!': 'Importação concluída!',
  'Importa contatos das conversas do Messenger via API do Meta.': 'Importa contatos das conversas do Messenger via API do Meta.',
  'Selecione a pagina...': 'Selecione a página...',
  'Periodo': 'Período',
  'Todo o periodo': 'Todo o período',
  'Importar todo o periodo pode levar alguns minutos...': 'Importar todo o período pode levar alguns minutos...',
  'Ultima vez': 'Última vez',
  'Todas paginas': 'Todas páginas',
  'Selecione uma pagina': 'Selecione uma página',

  // BROADCAST
  'Envie mensagens em massa para seus contatos': 'Envie mensagens em massa para seus contatos',
  'Selecione uma conta...': 'Selecione uma conta...',
  'Filtro de audiencia': 'Filtro de audiência',
  'Padrao (janela de 24h)': 'Padrão (janela de 24h)',
  'Alcance Maximo': 'Alcance Máximo',
  'Template rapido (opcional)': 'Template rápido (opcional)',
  'Botoes (opcional, max 3)': 'Botões (opcional, max 3)',
  '+ Adicionar botao': '+ Adicionar botão',
  'Resposta automatica': 'Resposta automática',
  'Variaveis e formatacao': 'Variáveis e formatação',
  'Atualizacoes de eventos confirmados': 'Atualizações de eventos confirmados',
  'Atualizacoes pos-compra': 'Atualizações pós-compra',
  'Notificacoes sobre a conta do usuario': 'Notificações sobre a conta do usuário',
  'Janela de 7 dias (nao 24h)': 'Janela de 7 dias (não 24h)',
  'Historico de Broadcasts': 'Histórico de Broadcasts',
  'Os broadcasts enviados aparecerão aqui': 'Os broadcasts enviados aparecerão aqui',
  'Acoes': 'Ações',
  'Proximo': 'Próximo',
  'Broadcast concluido!': 'Broadcast concluído!',
  'Configuracao': 'Configuração',
  'Usar tags incorretamente pode resultar em restricao da conta pelo Meta.': 'Usar tags incorretamente pode resultar em restrição da conta pelo Meta.',
  'Registro excluido': 'Registro excluído',
  'concluido': 'concluído',

  // BROADCAST TEMPLATES
  'Ligacao de video': 'Ligação de vídeo',
  'Notificacao pendente': 'Notificação pendente',
  'Presente pra voce': 'Presente pra você',
  'Ultimo aviso': 'Último aviso',
  'Alguem te mencionou': 'Alguém te mencionou',
  'Conteudo exclusivo': 'Conteúdo exclusivo',

  // RECUPERAR COMENTARIOS
  'Selecione a pagina para varrer todos os comentarios': 'Selecione a página para varrer todos os comentários',
  'Nenhuma pagina FB conectada': 'Nenhuma página FB conectada',
  'Conecte uma pagina Facebook com automacao FB ativa': 'Conecte uma página Facebook com automação FB ativa',
  'Comentarios dos ultimos 7 dias': 'Comentários dos últimos 7 dias',
  'Varrendo comentarios...': 'Varrendo comentários...',
  'Nenhum comentario nos ultimos 7 dias nesta pagina': 'Nenhum comentário nos últimos 7 dias nesta página',
  'unicos': 'únicos',
  'Comentadores (ultimos 7 dias)': 'Comentadores (últimos 7 dias)',
  'Comentadores (todos)': 'Comentadores (todos)',
  'Template rapido': 'Template rápido',
  'Erro ao carregar paginas': 'Erro ao carregar páginas',
  'Buscando todos os posts e comentadores de': 'Buscando todos os posts e comentadores de',
  'Varre todos os posts desta pagina e envia DM para cada comentador unico.': 'Varre todos os posts desta página e envia DM para cada comentador único.',
  'Bypassa a janela de 24h': 'Bypassa a janela de 24h',
  '1 por usuario': '1 por usuário',
  'Oi {{nome}}! Vi que voce comentou no nosso post...': 'Oi {{nome}}! Vi que você comentou no nosso post...',
  'Vi seu comentario': 'Vi seu comentário',

  // ADMIN
  'Painel administrativo do sistema': 'Painel administrativo do sistema',
  'Acao': 'Ação',
  'Senha deve ter no minimo 6 caracteres': 'Senha deve ter no mínimo 6 caracteres',
  'Cliente excluido!': 'Cliente excluído!',

  // MONITOR
  'Atividade do sistema em tempo real (atualiza a cada 3s)': 'Atividade do sistema em tempo real (atualiza a cada 3s)',

  // SEQUENCES
  'Drip campaigns - mensagens agendadas com delay em dias': 'Drip campaigns - mensagens agendadas com delay em dias',
  'Nova Sequencia': 'Nova Sequência',
  'Criar Sequencia': 'Criar Sequência',
  'Nenhuma sequencia': 'Nenhuma sequência',
  'Crie campanhas drip com mensagens agendadas por dias de delay.': 'Crie campanhas drip com mensagens agendadas por dias de delay.',
  'Sequencia criada!': 'Sequência criada!',
  'Sequencia excluida!': 'Sequência excluída!',
  'contatos inscritos!': 'contatos inscritos!',

  // CHECKER BOT
  'Descricao (opcional)': 'Descrição (opcional)',
  'Monte o roteiro de acoes que a extensao vai executar.': 'Monte o roteiro de ações que a extensão vai executar.',
  'URL da pagina': 'URL da página',
  'Roteiro copiado! Cole na extensao com "Importar Roteiro".': 'Roteiro copiado! Cole na extensão com "Importar Roteiro".',
  'Monte roteiros de checagem e exporte pra extensao': 'Monte roteiros de checagem e exporte pra extensão',
  'Extensao': 'Extensão',
  'Baixar Extensao': 'Baixar Extensão',
  'Crie seu primeiro roteiro de checagem para exportar pra extensao Chrome.': 'Crie seu primeiro roteiro de checagem para exportar pra extensão Chrome.',
  'Monte os passos: scroll, clique em seletores CSS, esperas entre acoes.': 'Monte os passos: scroll, clique em seletores CSS, esperas entre ações.',
  'Clique em "Copiar pro Extension" pra copiar o roteiro pra area de transferencia.': 'Clique em "Copiar pro Extension" pra copiar o roteiro pra área de transferência.',
  'Na extensao, clique em "Importar Roteiro" e cole o JSON copiado.': 'Na extensão, clique em "Importar Roteiro" e cole o JSON copiado.',
  'Selecione o roteiro e clique Executar. A extensao faz tudo automaticamente.': 'Selecione o roteiro e clique Executar. A extensão faz tudo automaticamente.',

  // FINANCIAL
  'Receitas, despesas e balanco da operacao': 'Receitas, despesas e balanço da operação',
  'Lancamento': 'Lançamento',
  'Novo Lancamento': 'Novo Lançamento',
  'Receita vs Despesa (6 meses)': 'Receita vs Despesa (6 meses)',
  'Por Categoria (mes atual)': 'Por Categoria (mês atual)',
  'Lancamentos': 'Lançamentos',
  'Nenhum lancamento encontrado.': 'Nenhum lançamento encontrado.',
  'Descricao': 'Descrição',
  'Editar Lancamento': 'Editar Lançamento',
  'Registre uma receita ou despesa da operacao.': 'Registre uma receita ou despesa da operação.',
  'Pagina (opcional)': 'Página (opcional)',
  'Geral (sem pagina)': 'Geral (sem página)',
  'Informe um valor valido': 'Informe um valor válido',
  'Lancamento atualizado!': 'Lançamento atualizado!',
  'Lancamento criado!': 'Lançamento criado!',
  'Lancamento deletado': 'Lançamento deletado',
  'Balanco Total': 'Balanço Total',
  'Saldo Mensal': 'Saldo Mensal',

  // PAGES
  'Gerenciamento de Paginas': 'Gerenciamento de Páginas',
  'Acompanhe suas paginas do Facebook': 'Acompanhe suas páginas do Facebook',
  'Nova Pagina': 'Nova Página',
  'Nenhuma pagina': 'Nenhuma página',
  'Nao monetizada': 'Não monetizada',
  'Editar Pagina': 'Editar Página',
  'Cadastre uma pagina do Facebook para acompanhamento.': 'Cadastre uma página do Facebook para acompanhamento.',
  'Nome da pagina': 'Nome da página',
  'Link da pagina': 'Link da página',
  'Esta pagina gera receita de anuncios?': 'Esta página gera receita de anúncios?',
  'Responsavel': 'Responsável',
  'Nome da pessoa responsavel': 'Nome da pessoa responsável',
  'Observacoes': 'Observações',
  'Anotacoes sobre a pagina...': 'Anotações sobre a página...',
  'Nenhum video. Clique em Sincronizar.': 'Nenhum vídeo. Clique em Sincronizar.',
  'Sem titulo': 'Sem título',
  'Informe o nome da pagina': 'Informe o nome da página',
  'Pagina atualizada!': 'Página atualizada!',
  'Pagina criada!': 'Página criada!',
  'Pagina deletada': 'Página deletada',
  'Cadastre suas paginas do Facebook para acompanhar monetizacao, seguidores e balanco.': 'Cadastre suas páginas do Facebook para acompanhar monetização, seguidores e balanço.',
  'Titulo': 'Título',
  'Ex: Receita de anuncios janeiro, Pagamento grupo X...': 'Ex: Receita de anúncios janeiro, Pagamento grupo X...',

  // CTM
  'Links + saudacao + botoes para reativar a janela de 24h': 'Links + saudação + botões para reativar a janela de 24h',
  'Mensagem de boas-vindas (opcional)': 'Mensagem de boas-vindas (opcional)',
  'Configuracao do Messenger': 'Configuração do Messenger',
  'Saudacao:': 'Saudação:',
  'Botao "Comecar"': 'Botão "Começar"',
  'Opcoes rapidas (Ice Breakers)': 'Opções rápidas (Ice Breakers)',
  'Comecar': 'Começar',
  'Mensagem automatica quando alguem clicar no link...': 'Mensagem automática quando alguém clicar no link...',
  'Saudacao + botao "Comecar" + opcoes rapidas que aparecem quando alguem abre o chat': 'Saudação + botão "Começar" + opções rápidas que aparecem quando alguém abre o chat',
  'Pagina → Configuracoes → Mensagens → Saudacao do Messenger': 'Página → Configurações → Mensagens → Saudação do Messenger',
  'Quando a pessoa clica "Comecar", envia esse payload e abre a janela de 24h automaticamente.': 'Quando a pessoa clica "Começar", envia esse payload e abre a janela de 24h automaticamente.',
  'Opcao': 'Opção',
  'Botoes que aparecem no chat. A pessoa clica e ja abre a janela sem precisar digitar.': 'Botões que aparecem no chat. A pessoa clica e já abre a janela sem precisar digitar.',
  'Configure a saudacao + botoes e crie um link': 'Configure a saudação + botões e crie um link',
  'Pessoa clica no botao': 'Pessoa clica no botão',
  'Clique em "Nova Campanha" para comecar': 'Clique em "Nova Campanha" para começar',

  // VISUAL FLOWS
  'Automacoes drag-and-drop com editor visual': 'Automações drag-and-drop com editor visual',
  'Crie fluxos drag-and-drop para automatizar respostas com logica avancada.': 'Crie fluxos drag-and-drop para automatizar respostas com lógica avançada.',

  // INPUT FLOWS
  'Keywords de gatilho (virgula)': 'Keywords de gatilho (vírgula)',
  'Mensagem de conclusao': 'Mensagem de conclusão',
  'Crie bots de perguntas para coletar dados automaticamente via DM.': 'Crie bots de perguntas para coletar dados automaticamente via DM.',
  'Excluido!': 'Excluído!',

  // POSTER
  'Gerencie e agende publicacoes para varias paginas': 'Gerencie e agende publicações para várias páginas',
  'Calendario': 'Calendário',
  'Salvar Alteracoes': 'Salvar Alterações',
  'Erro ao limpar programacoes': 'Erro ao limpar programações',

  // STORAGE
  'Comprar espaco': 'Comprar espaço',
  'Comprar mais espaco': 'Comprar mais espaço',
  'O espaco e adicionado automaticamente apos o pagamento': 'O espaço é adicionado automaticamente após o pagamento',
  'Cobranca gerada! Complete o pagamento via PIX.': 'Cobrança gerada! Complete o pagamento via PIX.',
  'Erro ao gerar cobranca': 'Erro ao gerar cobrança',

  // MEDIA
  'Gerencie suas imagens e videos, e corte videos em clips': 'Gerencie suas imagens e vídeos, e corte vídeos em clips',
  'Corte de Video': 'Corte de Vídeo',
  'Selecione uma pasta para ver o conteudo': 'Selecione uma pasta para ver o conteúdo',

  // CONFIRM DIALOGS
  'Os dados de fluxo desta conta serao perdidos.': 'Os dados de fluxo desta conta serão perdidos.',
  'Os lancamentos financeiros serao mantidos.': 'Os lançamentos financeiros serão mantidos.',
  'Deletar este lancamento?': 'Deletar este lançamento?',

  // YOUTUBE DUBBING
  'Nova Traducao / Dublagem': 'Nova Tradução / Dublagem',
  'URL do video (YouTube ou outro)': 'URL do vídeo (YouTube ou outro)',
  'Clique para selecionar video ou audio': 'Clique para selecionar vídeo ou áudio',
  'Idioma de destino': 'Idioma de destino',
  'Portugues': 'Português',
  'Ingles': 'Inglês',
  'Espanhol': 'Espanhol',
  'Frances': 'Francês',
  'Alemao': 'Alemão',
  'Japones': 'Japonês',
  'Chines': 'Chinês',
  'Arabe': 'Árabe',
  'Historico de Dublagens': 'Histórico de Dublagens',
  'Cole uma URL ou envie um video acima para comecar': 'Cole uma URL ou envie um vídeo acima para começar',
  'Concluido': 'Concluído',
  'Dublagem excluida': 'Dublagem excluída',

  // INSTAGRAM
  'Midias Recentes': 'Mídias Recentes',

  // INSTAGRAM COMMENTS
  'Comentarios': 'Comentários',
  'Nenhum comentario': 'Nenhum comentário',
  'Escrever comentario...': 'Escrever comentário...',
  'Comentario adicionado!': 'Comentário adicionado!',
  'Erro ao adicionar comentario': 'Erro ao adicionar comentário',
  'Comentario editado!': 'Comentário editado!',
  'Erro ao editar comentario': 'Erro ao editar comentário',
  'Comentario removido!': 'Comentário removido!',
  'Erro ao remover comentario': 'Erro ao remover comentário',

  // PAGE ENGAGEMENT
  'Engagement da Pagina': 'Engagement da Página',
  'Nenhuma pagina conectada': 'Nenhuma página conectada',
  'Selecionar pagina': 'Selecionar página',
  'Escreva um comentario...': 'Escreva um comentário...',
  'Comentario deletado!': 'Comentário deletado!',
  'Deletar este comentario?': 'Deletar este comentário?',
  'Deletar este post do Facebook? Essa acao nao pode ser desfeita.': 'Deletar este post do Facebook? Essa ação não pode ser desfeita.',
  'Ocultar comentarios': 'Ocultar comentários',

  // INSTAGRAM DM
  'ID do Destinatario': 'ID do Destinatário',

  // STATUS PAGE
  'Status dos Servicos': 'Status dos Serviços',
  'Monitoramento em tempo real de todos os servicos': 'Monitoramento em tempo real de todos os serviços',
  'Todos os servicos estao operacionais': 'Todos os serviços estão operacionais',
  'Alguns servicos apresentam problemas': 'Alguns serviços apresentam problemas',
  'Manutencao': 'Manutenção',

  // TRACKER
  'Rastreie visitantes dos seus sites em tempo real': 'Rastreie visitantes dos seus sites em tempo real',
  'Dominio': 'Domínio',
  'Dominio (ex: meusite.com.br)': 'Domínio (ex: meusite.com.br)',
  'Localizacao': 'Localização',
  'Historico': 'Histórico',
  'Unicos Hoje': 'Únicos Hoje',

  // SCHEDULE ALERT
  'sem videos agendados': 'sem vídeos agendados',

  // COMMON
  'Configuracoes': 'Configurações',
  'Pagina Facebook': 'Página Facebook',
}
